
import ReactPlayer from "react-player";
import "./precommon.css";

export default function PreWeddingVideo({ link }) {

  if (!link) return null;

  return (
    <>
      <div className="slider-header" data-aos="fade-up">
        <h2>Our Story</h2>
        <p>A few moments before forever</p>
      </div>

   <div data-aos="fade-up">
      <ReactPlayer
        url={link}
        className="pre-wedding-video-container"
        playing={false}
        playsinline
        controls={true}
        muted={false}
        volume={1}
      />
      </div>
    </>
  );
}